import Component from './direct_message_edit.vue'
export default Component
